/*=========================================================================================
  File Name: i18nSY.js
  Description: File đa ngôn ngữ cho phần hệ thống
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
    Author: nntam - 15/7/2019
    Modified: nnanh2 - 22/8/2019: Bổ sung localize
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
  RoleCode: "Mã vai trò",
  RoleName: "Tên vai trò",
  Role: "vai trò",
  Describe: "Mô tả",
  EditAndChooseUser: "Sửa và chọn người dùng",
  Add: "Thêm",
  RoleAndPermission: "Vai trò và quyền hạn",
  UserManagement: "Quản lý người dùng",
  GuideVideoText: "Xem video hướng dẫn",
  GuideArticleText: "Xem bài viết hướng dẫn",
  FullName: "Tên người dùng",
  MobilePhone: "Số điện thoại",
  Email: "Email",
  Status: "Trạng thái",
  EditAndChooseRole: "Sửa và chọn vai trò",
  ChooseUser: "Chọn người dùng",
  EditRole: "Sửa vai trò",
  AddRole: "Thêm vai trò",
  BranchWork: "Làm việc với chi nhánh",
  ChooseRole: "Chọn vai trò",
  EditUser: "Sửa người dùng",
  AddUser: "Thêm người dùng",
  User: "người dùng",
  AmisUser: "người dùng ứng dụng Kế toán",
  Authorization: "Phân quyền",
  SystemSetting: "Thiết lập",
  SetPermissionForRole: "Thiết lập quyền cho vai trò",
  StopActive: "Ngừng kích hoạt",
  StopWorking: "Ngừng hoạt động",
  ReActive: "Kích hoạt lại",
  Active: "Hoạt động",
  SearchByRole: "Tìm theo mã vai trò, tên vai trò",
  SearchByKeyWord: "Nhập từ khóa tìm kiếm",
  PhoneEmail: "Số điện thoại/Email",
  Fullname: "Họ và tên",
  Description: "Diễn giải",
  TourLabel: "Hướng dẫn",
  DeleteLayoutWarningMsg: "Bạn có muốn xóa mẫu ### đã chọn không?",
  Year: "Năm",
  FromDate: "Từ ngày",
  ToDate: "Đến ngày",
  PostedAccountLedger: "Hình thức sổ kế toán",
  PostAfterSave: "Chế độ ghi sổ",
  HelpAddUser: "Hướng dẫn thêm người dùng mới",
  SearchUsers: "Tìm kiếm người dùng",
  OrganizationUnitCode: "Mã đơn vị",
  OrganizationUnitName: "Tên đơn vị",
  IsUsingAdditionalBookManagement: "Sử dụng thêm hệ thống sổ quản trị",
  DeleteAllFilter: "Xóa điều kiện lọc",
  CustomizeLayout: "Tùy chỉnh giao diện",
  Action: "Cất",
  Cancel: "Hủy",
  GetDefaultLayout: "Lấy mẫu ngầm định",
  DataChanged:
    "Dữ liệu đã bị thay đổi do thay đổi kiểu dữ liệu trường mở rộng. Trang sẽ được tải lại ngay sau đây.",
  ChangeLinePosition: "Hướng dẫn thay đổi vị trí cột",
  ChangeLinePositionDescription:
    "Bấm giữ icon và di chuyển để thay đổi vị trí giữa các cột dữ liệu",
  DefaultLayout: "Mẫu chuẩn",
  DefaultLayoutForAllUsers: "Mẫu ngầm định (Mẫu được dùng khi lấy ngầm định)",
  ColumnDataFiled: "Trường dữ liệu trên DB",
  ForeignLayout: "Mẫu ngoại tệ",
  CustomLayout: "Mẫu tùy chỉnh",
  ColumnDataName: "Tên cột dữ liệu",
  ColumnInUI: "Tên cột",
  ColumnOrder: "STT",
  ColumnOrderTooltip: "Số thứ tự cột",
  ColumnNote: "Ghi chú",
  ColumnView: "Hiển thị",
  ColumnViewDev: "Hệ thống mang đi",
  ColumnType: "Kiểu dữ liệu",
  ShowWithVATMethod: "Hiển thị với PP tính thuế",
  ColumnFixed: "Cố định cột",
  ReadonlyColumn: "Không cho sửa",
  ColumnResize: "Co dãn cột",
  ColumnWidth: "Độ rộng",
  ColumnEnum: "Enum của cột",
  ExtraInformation: "Thông tin bổ sung",
  DetailExtraInformation: "Trường mở rộng chi tiết",
  AddExtraInformation: "Thêm thông tin bổ sung",
  ShowMoreData: "Hiển thị thêm",
  Feature: "Chức năng",
  ShowLessData: "Ẩn bớt",
  RateType: "Kiểu hệ số, tỷ lệ",
  ExchangeRateType: "Kiểu tỷ giá",
  UnitPriceOCType: "Kiểu đơn giá ngoại tệ",
  AmountOCType: "Kiểu tiền nguyên tệ",
  WorkDayType: "Kiểu số công",
  QuantityType: "Kiểu số lượng",
  DateType: "Kiểu ngày tháng",
  ListType: "Kiểu danh sách",
  NumberType: "Kiểu số nguyên",
  CheckBoxType: "Kiểu tích chọn",
  TextType: "Kiểu chữ",
  TimeType: "Kiểu thời gian",
  AllocationType: "Kiểu tỷ lệ phân bổ",
  LayoutName: "Tên mẫu",
  ReportName: "Tên báo cáo",
  CompanyInfo: "Thông tin công ty",
  ShowColumnData: "Hiển thị cột dữ liệu",
  GroupData: "Nhóm dữ liệu",
  Sign: "Chữ ký",
  AddColumn: "Thêm cột",
  EditColumn: "Sửa cột",
  DeleteColumn: "Xóa cột",
  CommonLayout: "Dùng chung cho tất cả mọi người dùng khác",
  EditColumnNameAndWidth: "Sửa tên cột hiển thị và độ rộng",
  AddColumnInstruction: "Nhấp đúp để chọn dòng trong danh sách vào công thức",
  GroupLevel1: "Mức 1",
  GroupLevel2: "Mức 2",
  GroupLevel3: "Mức 3",
  ColumnName: "Tên cột",
  ColumnEnglishName: "Tên Tiếng Anh",
  ColumnFormat: "Định dạng theo",
  ColumnFormula: "Công thức",
  ColumnGroup: "Nhóm cột với",
  Delete: "Xóa",
  Check: "Kiểm tra",
  Accept: "Đồng ý",
  AddValueTypeList: "Thêm giá trị kiểu dữ liệu danh sách ",
  CustomField1: "Trường mở rộng 1",
  CustomField2: "Trường mở rộng 2",
  CustomField3: "Trường mở rộng 3",
  CustomField4: "Trường mở rộng 4",
  CustomField5: "Trường mở rộng 5",
  CustomField6: "Trường mở rộng 6",
  CustomField7: "Trường mở rộng 7",
  CustomField8: "Trường mở rộng 8",
  CustomField9: "Trường mở rộng 9",
  CustomField10: "Trường mở rộng 10",
  Options: "Tùy chọn",
  OptionsGeneral: "Tùy chọn chung",
  SyncAMIS: "Đang đồng bộ dữ liệu từ AMIS hệ thống",
};
